// Shop page: instant filtering (no reloads), URL sync, live facets, active-filter
// chips, dual price slider, infinite scroll, grid/list view, mobile filter/sort sheets.
import { $, $$, api, cardHTML, esc, gradeLabel, icon, isAr, money, SPEC_LABELS, specValue, store, t } from "./util";
import { openSheet, closeSheet } from "./ui";
import { refreshMotion } from "./motion-lite";
import { syncAddButtons } from "./cart";

const PAGE = 24;

export function initShop2() {
	const root = $("[data-shop]");
	if (!root) return;
	const S = JSON.parse(root.dataset.shop);
	const grid = $("[data-grid]", root);
	const panel = $("[data-fpanel]", root);
	const empty = $("[data-empty]", root);
	const more = $("[data-more]", root);
	const shown = $("[data-shown]", root);
	let next = S.next, loading = false, reqId = 0;

	// ---- view (grid / list), remembered per visitor
	const setView = (v) => {
		grid.dataset.view = v;
		$$("[data-view]", root).forEach((b) => b.classList.toggle("is-on", b.dataset.view === v));
		store("darat_view", v);
	};
	setView(store("darat_view") || "grid");
	root.addEventListener("click", (e) => { const b = e.target.closest("button[data-view]"); if (b) setView(b.dataset.view); });

	// ---- price slider
	const pr = { min: $("[data-pr=min]", root), max: $("[data-pr=max]", root), fill: $("[data-price-fill]", root) };
	const setBounds = (lo, hi) => {
		[pr.min, pr.max].forEach((r) => { r.min = lo; r.max = hi; r.step = Math.max(1, Math.round((hi - lo) / 200)); });
		pr.min.value = S.min || lo; pr.max.value = S.max || hi;
		paintRange();
	};
	const paintRange = () => {
		const lo = +pr.min.min, hi = +pr.min.max || 1, a = +pr.min.value, b = +pr.max.value;
		const s = ((Math.min(a, b) - lo) / (hi - lo)) * 100, e = ((Math.max(a, b) - lo) / (hi - lo)) * 100;
		pr.fill.style.insetInlineStart = s + "%"; pr.fill.style.width = e - s + "%";
	};
	if (pr.min) {
		setBounds(S.pmin, S.pmax);
		const onSlide = () => {
			if (+pr.min.value > +pr.max.value) [pr.min.value, pr.max.value] = [pr.max.value, pr.min.value];
			paintRange();
			$("[data-f=min]", root).value = +pr.min.value > +pr.min.min ? pr.min.value : "";
			$("[data-f=max]", root).value = +pr.max.value < +pr.max.max ? pr.max.value : "";
		};
		[pr.min, pr.max].forEach((r) => { r.addEventListener("input", onSlide); r.addEventListener("change", () => apply()); });
	}

	// ---- read state from controls
	const read = () => {
		S.q = ($("[data-f=q]", root)?.value || "").trim();
		S.in_stock = $("[data-f=in_stock]", root)?.checked ? 1 : 0;
		S.min = $("[data-f=min]", root)?.value || "";
		S.max = $("[data-f=max]", root)?.value || "";
		S.sort = $("[data-f=sort]", root)?.value || S.sort;
		if (!S.brandRoute) S.brand = $$("[data-facet-brands] input:checked", root).map((i) => i.value);
		S.spec = $$("[data-facet=spec]:checked", root).map((i) => i.value);
		S.grade = $$("[data-facet=grade]:checked", root).map((i) => i.value);
		const fit = $("[data-f=fit]", root);
		S.fit = fit && fit.checked ? fit.value : "";
	};
	const params = (start) => ({
		q: S.q, group: S.group, brand: S.brandRoute || S.brand.join(","), in_stock: S.in_stock || "", min_price: S.min, max_price: S.max,
		sort: S.sort, start, page_len: PAGE, spec: S.spec.join(","), grade: S.grade.join(","), fit: S.fit || "",
	});
	const syncUrl = () => {
		const u = new URL(S.base, location.origin);
		if (S.q) u.searchParams.set("q", S.q);
		if (!S.brandRoute && S.brand.length) u.searchParams.set("brand", S.brand.join(","));
		if (S.in_stock) u.searchParams.set("in_stock", 1);
		if (S.min) u.searchParams.set("min", S.min);
		if (S.max) u.searchParams.set("max", S.max);
		if (S.sort && S.sort !== "relevance") u.searchParams.set("sort", S.sort);
		if (S.spec.length) u.searchParams.set("spec", S.spec.join(","));
		if (S.grade.length) u.searchParams.set("grade", S.grade.join(","));
		if (S.fit) u.searchParams.set("fit", S.fit);
		const lang = new URL(location.href).searchParams.get("_lang"); if (lang) u.searchParams.set("_lang", lang);
		history.replaceState(null, "", u);
	};

	// ---- chips for active filters
	const chips = () => {
		const out = [];
		if (S.q) out.push(["q", `“${S.q}”`]);
		if (S.in_stock) out.push(["in_stock", t("المتوفر فقط", "In stock")]);
		if (S.fit) out.push(["fit", `${t("يناسب", "Fits")} ${S.fitLabel || S.fit}`]);
		if (S.min || S.max) out.push(["price", `${S.min ? money(S.min) : "…"} – ${S.max ? money(S.max) : "…"}`]);
		if (!S.brandRoute) S.brand.forEach((b) => out.push(["brand:" + b, b]));
		S.grade.forEach((g) => out.push(["grade:" + g, gradeLabel(g)]));
		S.spec.forEach((v) => out.push(["spec:" + v, specValue(v.split(":").slice(1).join(":"))]));
		$("[data-chips]", root).innerHTML = out.map(([k, l]) => `<button type="button" class="ds-achip" data-unset="${esc(k)}">${esc(l)}${icon("x")}</button>`).join("")
			+ (out.length > 1 ? `<button type="button" class="ds-link" data-clear-all>${t("مسح الكل", "Clear all")}</button>` : "");
		const n = out.length;
		$$("[data-fcount]", root).forEach((el) => { el.textContent = n; el.hidden = !n; });
	};

	S.spec = S.spec || []; S.grade = S.grade || [];
	// "Parts for my laptop only": offered when the visitor saved a laptop (or arrived with ?fit=)
	const mine = store("darat_mylaptop"), fitIn = $("[data-f=fit]", root);
	if (fitIn && !S.fit && mine && mine.slug) {
		fitIn.value = mine.slug; S.fitLabel = mine.label;
		$("[data-fit-label]", root).textContent = mine.label;
		$("[data-fit-wrap]", root).hidden = false;
	}
	const facetGroup = (title, key, items, label) => `<details class="ds-fgroup" open><summary>${esc(title)}${icon("chevron", "ds-rot90")}</summary>
		<div class="ds-fbrands ds-fspecs">${items.map((x) => {
			const val = key === "grade" ? x.v : `${key}:${x.v}`;
			const on = key === "grade" ? S.grade.includes(x.v) : S.spec.includes(val);
			return `<label class="ds-fbrand"><input type="checkbox" data-facet="${key === "grade" ? "grade" : "spec"}" value="${esc(val)}" ${on ? "checked" : ""}>
				<span class="ds-fbrand__box">${icon("check")}</span><span class="ds-fbrand__name" dir="auto">${esc(label ? label(x.v) : x.v)}</span><small>${x.count}</small></label>`;
		}).join("")}</div></details>`;
	const renderSpecs = (specs, grades) => {
		const g = $("[data-facet-grades]", root), sp = $("[data-facet-specs]", root);
		if (g) g.innerHTML = grades && grades.length > 0 ? facetGroup(t("الجودة", "Quality"), "grade", grades, gradeLabel) : "";
		if (sp) sp.innerHTML = Object.entries(specs || {}).map(([k, vals]) => facetGroup(SPEC_LABELS[k] || k, k, vals, specValue)).join("");
	};
	renderSpecs(S.specs, S.grades);

	const renderBrands = (list) => {
		const box = $("[data-facet-brands]", root);
		if (!box) return;
		const sel = new Set(S.brand);
		const all = [...list];
		S.brand.forEach((b) => { if (!all.find((x) => x.name === b)) all.unshift({ name: b, ar: b, count: 0, logo: "" }); });
		box.innerHTML = all.map((b) => `<label class="ds-fbrand"><input type="checkbox" value="${esc(b.name)}" ${sel.has(b.name) ? "checked" : ""}>
			<span class="ds-fbrand__box">${icon("check")}</span>
			<span class="ds-fbrand__logo">${b.logo ? `<img src="${esc(b.logo)}" alt="" loading="lazy">` : `<b>${esc(b.name.slice(0, 2))}</b>`}</span>
			<span class="ds-fbrand__name">${esc(isAr ? b.ar : b.name)}</span><small>${b.count}</small></label>`).join("");
		filterBrands();
	};
	const filterBrands = () => {
		const q = ($("[data-brand-search]", root)?.value || "").toLowerCase();
		$$(".ds-fbrand", root).forEach((l) => (l.hidden = q && !l.textContent.toLowerCase().includes(q)));
	};
	$("[data-brand-search]", root)?.addEventListener("input", filterBrands);

	const setTotal = (n) => $$("[data-total]").forEach((el) => (el.textContent = n));
	const setShown = (total) => { if (shown) shown.textContent = total ? `${t("عرض", "Showing")} ${grid.querySelectorAll(".ds-card").length} ${t("من", "of")} ${total}` : ""; };

	// ---- fetch
	async function apply() {
		read(); syncUrl(); chips();
		const id = ++reqId;
		grid.classList.add("is-busy");
		try {
			const res = await api("darat.storefront.api.products", { ...params(0), with_facets: 1 });
			if (id !== reqId) return;
			grid.innerHTML = res.items.map(cardHTML).join("");
			empty.hidden = !!res.items.length;
			next = res.items.length < res.total ? res.items.length : 0;
			setTotal(res.total); setShown(res.total);
			if (res.facets) {
				renderBrands(res.facets.brands);
				renderSpecs(res.facets.specs, res.facets.grades);
				if (pr.min && !S.min && !S.max) { S.pmin = res.facets.price_min; S.pmax = res.facets.price_max; setBounds(S.pmin, S.pmax); }
			}
			refreshMotion(grid); syncAddButtons();
			if (window.matchMedia("(min-width: 961px)").matches) {
				const top = root.getBoundingClientRect().top + scrollY - 140;
				if (scrollY > top) (window.__lenis ? window.__lenis.scrollTo(top) : scrollTo({ top, behavior: "smooth" }));
			}
		} catch (e) { /* keep current results */ }
		grid.classList.remove("is-busy");
	}
	async function loadMore() {
		if (!next || loading) return;
		loading = true; more.classList.add("is-loading");
		try {
			const res = await api("darat.storefront.api.products", params(next));
			grid.insertAdjacentHTML("beforeend", res.items.map(cardHTML).join(""));
			next = res.start + res.items.length < res.total ? res.start + res.items.length : 0;
			setShown(res.total); refreshMotion(grid); syncAddButtons();
		} catch (e) { /* retry on next intersection */ }
		loading = false; more.classList.remove("is-loading");
	}
	if ("IntersectionObserver" in window) new IntersectionObserver(([en]) => en.isIntersecting && loadMore(), { rootMargin: "900px" }).observe(more);
	setShown(S.total); chips();

	// ---- events
	let tmr;
	root.addEventListener("input", (e) => {
		if (e.target.matches("[data-f=q], [data-f=min], [data-f=max]")) { clearTimeout(tmr); tmr = setTimeout(apply, 380); }
	});
	root.addEventListener("change", (e) => {
		if (e.target.matches("[data-f=in_stock], [data-f=fit], [data-f=sort], [data-facet-brands] input, [data-facet]")) apply();
	});
	document.addEventListener("click", (e) => {
		const un = e.target.closest("[data-unset]");
		if (un) {
			const k = un.dataset.unset;
			if (k === "q") $("[data-f=q]", root).value = "";
			if (k === "in_stock") $("[data-f=in_stock]", root).checked = false;
			if (k === "fit" && $("[data-f=fit]", root)) $("[data-f=fit]", root).checked = false;
			if (k === "price") { $("[data-f=min]", root).value = ""; $("[data-f=max]", root).value = ""; if (pr.min) setBounds(+pr.min.min, +pr.min.max); }
			if (k.startsWith("brand:")) $$("[data-facet-brands] input", root).forEach((i) => { if (i.value === k.slice(6)) i.checked = false; });
			if (k.startsWith("grade:")) $$("[data-facet=grade]", root).forEach((i) => { if (i.value === k.slice(6)) i.checked = false; });
			if (k.startsWith("spec:")) $$("[data-facet=spec]", root).forEach((i) => { if (i.value === k.slice(5)) i.checked = false; });
			apply();
		}
		if (e.target.closest("[data-clear-all]")) {
			$("[data-f=q]", root).value = ""; $("[data-f=in_stock]", root).checked = false;
			if ($("[data-f=fit]", root)) $("[data-f=fit]", root).checked = false;
			$("[data-f=min]", root).value = ""; $("[data-f=max]", root).value = "";
			$$("[data-facet-brands] input, [data-facet]", root).forEach((i) => (i.checked = false));
			S.min = S.max = ""; apply();
		}
		if (e.target.closest("[data-fopen]")) { panel.classList.add("is-open"); document.documentElement.style.overflow = "hidden"; }
		if (e.target.closest("[data-fclose]")) { panel.classList.remove("is-open"); document.documentElement.style.overflow = ""; }
		if (e.target.closest("[data-sort-open]")) openSheet("sort");
		const so = e.target.closest("[data-sort]");
		if (so) {
			$$("[data-sort]").forEach((b) => b.classList.toggle("is-on", b === so));
			const sel = $("[data-f=sort]", root); sel.value = so.dataset.sort; sel.dispatchEvent(new Event("change", { bubbles: true }));
			closeSheet(so.closest("[data-sheet]"));
		}
	});
}
